import React, { PropTypes } from 'react';
import classNames from 'classnames';
import uuid from 'uuid';
import AnimateOnChange from 'react-animate-on-change';
import Field from '../Field/Field';
import './Checkbox.less';

class Checkbox extends Field {
  constructor(props) {
    super(props);

    this.inputId = uuid.v1();
  }

  render () {
    const {inputId} = this;
    const {className, label, checked, onChange} = this.props;
    const {animateError} = this.state;
    const rootClasses = classNames('input-field checkbox', className);

    return (
      <AnimateOnChange
          baseClassName={rootClasses}
          animationClassName="shake--active"
          animate={animateError}>
        <input type="checkbox" checked={checked} id={inputId} onChange={e => {onChange && onChange(!!e.target.checked);}}/>
        {label && (<label htmlFor={inputId}>{label}</label>)}
      </AnimateOnChange>
    );
  }
}

Checkbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/common/Checkbox/Checkbox.js